import React from "react";
import Popup from "reactjs-popup";
import { ReactComponent as LinkIcon } from "../../../images/link.svg";
import Tag from "../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../app/data/common/tagColor";
import {
  PROCESSING_STATE_COLORS,
  formatProcessingStatusTag,
} from "../../pickup/inbox/constants";
import "./emailViewer.scss";
import { InboundProcessingState } from "../../../app/data/communications/models";

export interface EmailHeaderPanelProps {
  sender?: string;
  receiver?: string;
  subject?: string;
  receivedAt?: string;
  processingState?: InboundProcessingState;
  pendingReviewCount?: number;
  webLink?: string;
  onViewEmail?: () => void;
  viewEmailAsLink?: boolean;
}

const formatReceived = (receivedAt?: string) => {
  if (!receivedAt) return "—";
  return receivedAt.toUiDateTimeFormat?.() ?? receivedAt;
};

const EmailHeaderPanel: React.FC<EmailHeaderPanelProps> = ({
  sender,
  receiver,
  subject,
  receivedAt,
  processingState,
  pendingReviewCount,
  webLink,
  onViewEmail,
  viewEmailAsLink = true,
}) => {
  const processingTag =
    processingState != null ? formatProcessingStatusTag(processingState) : null;

  return (
  <div className="xgs-email-header-panel">
    <div className="xgs-email-header-panel__primary">
      {subject && <h2 className="xgs-email-header-panel__subject">{subject}</h2>}
      <div className="xgs-email-header-panel__grid">
        <div className="xgs-email-header-panel__field">
          <span className="xgs-email-header-panel__field-label">From</span>
          <span className="xgs-email-header-panel__field-value">{sender || "—"}</span>
        </div>
        {receiver && (
          <div className="xgs-email-header-panel__field">
            <span className="xgs-email-header-panel__field-label">To</span>
            <span className="xgs-email-header-panel__field-value">{receiver}</span>
          </div>
        )}
        <div className="xgs-email-header-panel__field">
          <span className="xgs-email-header-panel__field-label">Received</span>
          <span className="xgs-email-header-panel__field-value">{formatReceived(receivedAt)}</span>
        </div>
      </div>
      {(processingTag || (pendingReviewCount != null && pendingReviewCount > 0)) && (
        <div className="xgs-email-header-panel__tags">
          {processingTag && (
            <Tag mods={{ color: PROCESSING_STATE_COLORS[processingState!], uppercase: false }}>
              {processingTag}
            </Tag>
          )}
          {pendingReviewCount != null && pendingReviewCount > 0 && (
            <Tag mods={{ color: TagColor.ORANGE, uppercase: false }}>
              {pendingReviewCount} Pending
            </Tag>
          )}
        </div>
      )}
    </div>
    <div className="xgs-email-header-panel__actions">
      {viewEmailAsLink && onViewEmail && (
        <button type="button" className="xgs-email-header-panel__view-link" onClick={onViewEmail}>
          View email
        </button>
      )}
      {webLink && (
        <Popup
          trigger={
            <a
              className="xgs-email-header-panel__outlook-link"
              href={webLink}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <LinkIcon />
              Open in Outlook
            </a>
          }
          position="bottom right"
          on={["hover"]}
          offsetY={5}
          arrowStyle={{ borderWidth: "0px", transform: "translate(40px)" }}
          contentStyle={{
            borderRadius: "4px",
            boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.20)",
            borderWidth: "0px",
            padding: "16px",
            width: "180px",
          }}
        >
          <div className="xgs-email-header-panel__tooltip">
            Original email will be available based on permissions.
          </div>
        </Popup>
      )}
    </div>
  </div>
  );
};

export default EmailHeaderPanel;
